import axios from "axios";
import { INVITATION_URL } from "shared/constants/backend";
import { Invitation } from "shared/models";
import { generateAuthorizationHeaders } from "shared/utils";

export async function getAllInvitations(token = ""): Promise<Invitation[]> {
  const headers = generateAuthorizationHeaders(token);
  const response = await axios.get(`${INVITATION_URL}/`, {
    headers,
  });
  return response.data;
}

export async function getInvitationById(
  invitationId: string,
  token = ""
): Promise<Invitation> {
  const headers = generateAuthorizationHeaders(token);

  const response = await axios.get(`${INVITATION_URL}/${invitationId}/`, {
    headers,
  });
  return response.data;
}

export async function sendInvite(
  invitedUser: Invitation,
  token = ""
): Promise<Invitation> {
  const headers = generateAuthorizationHeaders(token);
  const response = await axios.post(`${INVITATION_URL}/`, invitedUser, {
    headers,
  });
  return response.data;
}

export async function revokeInvitation(
  invitationId: string,
  token = ""
): Promise<void> {
  const headers = generateAuthorizationHeaders(token);

  const response = await axios.delete(`${INVITATION_URL}/${invitationId}/`, {
    headers,
  });

  return response.data;
}

export async function resendInvitation(
  invitationId: string,
  token = ""
): Promise<Invitation> {
  const headers = generateAuthorizationHeaders(token);
  const response = await axios.post(
    `${INVITATION_URL}/${invitationId}/resend/`,
    {},
    {
      headers,
    }
  );
  return response.data;
}
